module.exports = __webpack_public_path__ + "static/media/invoices.401cd26a.svg";